module.exports = __webpack_public_path__ + "static/media/Tentacool_gaussian2.a408cc3d.png";